import { html } from "lit";

export function Template(args) {
    return html`
        <div class="row">
            <div class="gr-10@d push-1@d gr-10@large push-1@large gr-12">
                <div class="u-textCenter">
                    <h2 class="headline-giant">
                        <span class="text-results"
                            >Success Stories at TRUMPF</span
                        >
                    </h2>
                </div>
                <div class="row">
                    <div class="gr-12">
                        <span class="ux-label"> Filters </span>
                    </div>
                </div>
                <!-- FILTER ELEMENT: give a unique id to the ux-filter component -->
                <ux-filter id="success-stories-filter">
                    <div class="row">
                        <div class="gr-12 no-gutter">
                            <div class="row">
                                <div
                                    class="gr-3 gr-6@t gr-12@m ux-u-margin-bottom-20"
                                >
                                    <ux-dropdown
                                        name="filter"
                                        placeholder="Filter 1"
                                    >
                                        <!-- insert all the filter for the first dropdown here -->
                                        ${checkboxListItems(
                                            "filter",
                                            Array(10)
                                                .fill(1)
                                                .map((x, y) => x + y)
                                        )}
                                    </ux-dropdown>
                                </div>
                                <div
                                    class="gr-3 gr-6@t gr-12@m ux-u-margin-bottom-20"
                                >
                                    <ux-dropdown
                                        name="filter"
                                        placeholder="Filter 2"
                                    >
                                        <!-- insert all the filter for the second dropdown here -->
                                        ${checkboxListItems(
                                            "filter",
                                            Array(10)
                                                .fill(11)
                                                .map((x, y) => x + y)
                                        )}
                                    </ux-dropdown>
                                </div>
                                <div
                                    class="gr-3 gr-6@t gr-12@m ux-u-margin-bottom-20"
                                >
                                    <ux-dropdown
                                        name="filter"
                                        placeholder="Filter 3"
                                    >
                                        ${checkboxListItems(
                                            "filter",
                                            Array(10)
                                                .fill(21)
                                                .map((x, y) => x + y)
                                        )}
                                    </ux-dropdown>
                                </div>
                                <div
                                    class="gr-3 gr-6@t gr-12@m ux-u-margin-bottom-20"
                                >
                                    <ux-dropdown
                                        name="filter"
                                        placeholder="Filter 4"
                                    >
                                        ${checkboxListItems(
                                            "filter",
                                            Array(20)
                                                .fill(31)
                                                .map((x, y) => x + y)
                                        )}
                                    </ux-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- active filter section, will be managed entirely by the frontend component -->
                    <div class="row">
                        <div
                            class="gr-12 ux-u-text-uppercase"
                            style="min-height: 40px;"
                        >
                            <span
                                class="ux-text-tiny ux-text-tiny--bold ux-u-margin-right-10"
                            >
                                Active filters:
                            </span>
                            <div class="ux-tag-list"></div>
                            <span class="ux-filter__remove-all">
                                Clear Filters
                                <ux-icon name="close"></ux-icon>
                            </span>
                        </div>
                    </div>
                </ux-filter>
            </div>
            <div class="u-clearfix"></div>
        </div>
        <div class="row ux-u-background-grey-faded-vertical-upsidedown">
            <div class="ux-arrow-divider ux-arrow-divider--with-shadow"></div>
            <div
                class="gr-10 push-1 gr-12@m push-0@m ux-u-background-white ux-u-margin-vertical-20"
            >
                <ux-iws-data-controller-success-stories
                    filter-selector="#success-stories-filter"
                    src="${args.mockDataUrl}"
                    counter-selector=".success-stories-counter"
                    error-text="There was an error"
                    filter-attribute-identifier="success-story"
                >
                    <div class="row" slot="counter">
                        <div class="gr-12 ux-u-margin-vertical-40">
                            <div class="ux-u-text-align--center">
                                <span
                                    class="headline-medium ux-u-text-bold success-stories-counter"
                                >
                                    43
                                </span>
                                <span class="headline-medium">
                                    Results found
                                </span>
                            </div>
                        </div>
                    </div>
                    <div
                        class="ux-iws-teaser-image-grid ux-iws-teaser-image-grid--3-xl"
                        slot="results-container"
                    >
                        ${args.withPreview
                            ? html`<ux-iws-teaser-image
                                  image-ratio="17:8"
                                  class="ux-u-margin-bottom-30"
                                  data-ux-success-story-filter="7,15,26,40"
                              >
                                  <div slot="tags">
                                      <ux-tag
                                          data-ux-iws-link-wrapper-ignore
                                          data-ux-success-story-tag="7"
                                          >Tag 7</ux-tag
                                      ><ux-tag
                                          data-ux-iws-link-wrapper-ignore
                                          data-ux-success-story-tag="15"
                                          >Tag 15</ux-tag
                                      ><ux-tag
                                          data-ux-iws-link-wrapper-ignore
                                          data-ux-success-story-tag="26"
                                          >Tag 26</ux-tag
                                      ><ux-tag
                                          data-ux-iws-link-wrapper-ignore
                                          data-ux-success-story-tag="40"
                                          >Tag 40</ux-tag
                                      >
                                  </div>
                                  <strong
                                      class="ux-text-tiny ux-text-tiny--bold ux-u-text-uppercase"
                                      slot="label"
                                  >
                                      teaser box label
                                  </strong>
                                  <h5
                                      class="ux-u-margin-top-0 ux-u-margin-bottom-10 ux-text-headline ux-text-headline--medium"
                                      slot="headline"
                                  >
                                      Teaser box headline
                                  </h5>
                                  <ux-text-lines-limit
                                      text-lines="4"
                                      slot="text"
                                  >
                                      <div
                                          class="ux-text-normal ux-text-normal--light-gray"
                                      >
                                          Lorem ipsum dolor sit amet, consetetur
                                          sadipscing elitr, sed diam nonumy
                                          eirmod tempor invidunt ut labore et
                                          dolore magna aliquyam erat, sed diam
                                          voluptua. At vero eos et accusam et
                                          justo duo dolores et. sed diam
                                          voluptua. At vero eos et accusam et
                                          justo duo dolores et. Lorem ipsum
                                          dolor sit amet, consetetur sadipscing
                                          elitr, sed diam nonumy nvidunt ut
                                          labore et dolore magna aliquyam erat.
                                      </div>
                                  </ux-text-lines-limit>
                                  <div slot="cta">
                                      <a
                                          class="ux-button ux-button--icon-only"
                                          href="#"
                                          aria-label="Lorem Ipsum"
                                          role="button"
                                      >
                                          <ux-icon
                                              name="chevron-right"
                                              weight="normal"
                                          ></ux-icon>
                                      </a>
                                  </div>
                              </ux-iws-teaser-image>`
                            : html``}
                    </div>
                </ux-iws-data-controller-success-stories>
            </div>
        </div>
    `;
}

function checkboxListItems(filterName, values) {
    return html`
        ${values.map((value) => {
            return html`
                <ux-checkbox-list-item
                    name="${filterName}"
                    value="${value}"
                    label="Entry ${value}"
                ></ux-checkbox-list-item>
            `;
        })}
    `;
}
